<div class="modal-header blue">
  <h4 class="modal-title">
    {{
      isReadOnly
        ? 'Provider (' + providerId + ')'
        : this.actionText + 'Provider (' + providerId + ')'
    }}
  </h4>
  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<form [formGroup]="providerForm">
  <div
    class="modal-body provider"
    [class.loading]="isLoading"
    [class.next-step]="false"
  >
    <div class="d-flex flex-column">
      <ul
        ngbNav
        #nav="ngbNav"
        [destroyOnHide]="false"
        [(activeId)]="activeTabNumber"
        class="nav-tabs mb-3"
      >
        <li [ngbNavItem]="1">
          <a ngbNavLink>Provider Details</a>
          <ng-template ngbNavContent>
            <div class="row">
              <div class="col">
                <div class="mb-3">
                  <div class="input-label">
                    <span class="standart-text-required-symbol">*</span>
                    First name
                  </div>
                  <input
                    type="text"
                    placeholder="Enter First Name"
                    class="input"
                    formControlName="firstName"
                    maxLength="35"
                  />
                </div>

                <div class="mb-3">
                  <div class="input-label">
                    <span class="standart-text-required-symbol">*</span>
                    last name
                  </div>
                  <input
                    type="text"
                    placeholder="Enter Last Name"
                    class="input"
                    formControlName="lastName"
                    maxLength="65"
                  />
                </div>

                <div class="mb-3">
                  <div class="input-label">mi</div>
                  <input
                    type="text"
                    placeholder="Enter MI"
                    class="input"
                    formControlName="mi"
                    maxlength="1"
                  />
                </div>

                <div class="mb-3">
                  <div class="input-label">degree</div>
                  <input
                    type="text"
                    placeholder="Enter Degree"
                    class="input"
                    formControlName="degree"
                    maxlength="5"
                  />
                </div>

                <div class="">
                  <ddl-practice
                    formControlName="pms"
                    class="mt-2"
                  ></ddl-practice>
                </div>
              </div>

              <div class="col">
                <section-contact formGroupName="contact"></section-contact>
              </div>

              <div class="col">
                <section-status-dates
                  [formGroup]="providerForm"
                  [isEditMode]="false"
                >
                </section-status-dates>

                <div class="mb-3 mt-3">
                  <div class="input-label">
                    <span class="standart-text-required-symbol">*</span>
                    certification status
                  </div>

                  <div
                    class="d-flex"
                    [class.disabled]="providerForm.get('certified')?.disabled"
                  >
                    <label class="input-wrap radio mr-3">
                      <input
                        type="radio"
                        value="P"
                        formControlName="certified"
                      />
                      <span class="text">Production</span>
                    </label>
                    <label class="input-wrap radio">
                      <input
                        type="radio"
                        value="T"
                        formControlName="certified"
                      />
                      <span class="text">Test</span>
                    </label>
                  </div>
                </div>

                <div class="input-label">
                  <span class="standart-text-required-symbol">*</span>
                  fee schedule
                </div>
                <div
                  class="input-wrap select"
                  [class.disabled]="providerForm.get('feeSchedule')?.disabled"
                >
                  <select class="input" formControlName="feeSchedule">
                    <option [value]="''" selected="selected" disabled>
                      Select Fee Schedule
                    </option>
                    <ng-container *ngFor="let fee of fees">
                      <option [value]="fee.id" title="{{ fee.name }}">
                        {{ fee.name }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col">
                <section-address formGroupName="address"></section-address>
              </div>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink>Identifiers</a>
          <ng-template ngbNavContent>
            <qualifiers-grid
              [groupId]="groupId"
              [providerId]="providerId"
              [isProvider]="true"
              [isReadOnly]="isReadOnly"
            >
            </qualifiers-grid>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      class="button ml-auto w-134px"
      *ngIf="!isReadOnly"
      (click)="save()"
      [disabled]="providerForm.invalid"
    >
      {{ this.isViewMode ? 'Close' : 'Save' }}
    </button>
  </div>
</form>
